/********************************************
 * FAQ Carousel
*
* Flickity carousel
* https://flickity.metafizzy.co/
********************************************/
function fnFaqCarousel( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection				= $( oSection ),
		oCarousel				= $( '.carousel', oSection ),
		oArrows					= $( 'nav.arrows', oSection ),
		oBar					= $( '.progress-bar', oSection ),
		iCurrentSlide;


	/*****************
	* Carousel configuration
	*****************/

	/**
	* Initialise Flickity
	*/
	var $oFlickity				= oCarousel.flickity({
		cellAlign: 					'left',
		adaptiveHeight: true,
		freeScroll: 				true,
		freeScrollFriction: 		0.075,
		contain: 					true,
		accessibility: 				false,
		prevNextButtons: 			false,
		pageDots: 					false
	});

	/**
	* Store carousel data
	*/
	var aCarouselData			= $oFlickity.data( 'flickity' ),
		iTotalSlides			= aCarouselData.slides.length;

	/**
	* Arrow buttons (prev/next)
	*/
	oArrows.find( 'i.next' ).on( 'click', function() {
		$oFlickity.flickity( 'next' );
	});
	oArrows.find( 'i.prev' ).on( 'click', function() {
		$oFlickity.flickity( 'previous' );
	});

	/**
	* Progress bar
	*/
	// Update progress bar on load
	oBar.find( '.current' ).css( 'width', ( 100 / ( iTotalSlides - 1 ) ) * 1 + '%' );

	// On scroll
	$oFlickity.on( 'scroll.flickity', function( event, iProgress ) {

		// Current slide
		iCurrentSlide			= aCarouselData.selectedIndex + 1;

		// Calculate progress
		iSlideBarWidth			= 100 / ( iTotalSlides - 1 );
		iProgress				= ( ( iProgress * 100 ) + iSlideBarWidth );

		// Update progress bar
		oBar.find( '.current' ).css( 'width', iProgress + '%' );

	});

}


// END OF DOCUMENT
